/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CameraEventReplayStatus = {
    NotReplayed: 'NotReplayed',
    Queued: 'Queued',
    Replayed: 'Replayed',
    Failed: 'Failed'
} as const;
export type CameraEventReplayStatus = typeof CameraEventReplayStatus[keyof typeof CameraEventReplayStatus];

